import React from 'react';
import ReactDOM from 'react-dom';

import AssetLibraryContainer from 'ub/components/asset-library/asset-library-container';

export default class AssetLibraryWrapper {
  constructor(editor) {
    this.editor = editor;

    this.container = document.createElement('div');
    editor.e.appendChild(this.container);

    this.render(false);
  }

  open(options) {
    this.render(true, options);
  }

  render(isOpen, options = {}) {
    ReactDOM.render(
      <AssetLibraryContainer
        isOpen={isOpen}
        onChoose={options.onChoose || options.callback}
        onClose={options.onCancel}
        selectedAssetUuids={options.selectedAsset ? [options.selectedAsset.uuid] : undefined}
        selectedType={options.activeTab}
        title={options.title}
        uploadButtonText={options.uploadButtonLabel}
        visibleTypes={options.onlyImages ? ['images'] : options.visibleTabs}
      />,
      this.container
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/asset-library/index.jsx